<div class="responsive-container p-grid">
  <p-panel>
    <ng-template pTemplate="header">
      <div class="responsive-header">
        <div>
          <span class="responsive-header-title">
            Salida de Artículos
            <p class="responsive-header-subtitle">Cuenta: {{ accountName }}
              @if (itemGroupId) {
              <span> | Grupo: {{ itemGroupId }}</span>
              }
            </p>
          </span>
        </div>

        <div class="flex gap-2 align-items-center">
          <button pButton icon="pi pi-times" class="p-button-rounded p-button-text" (click)="onClose()"></button>
        </div>
      </div>
    </ng-template>

    <p-fluid>
      <div class="content">
        <!-- View Messages -->
        <p-toast [breakpoints]="{ '920px': { width: '100%', right: '0', left: '0' } }" />

        @if (!release) {
        <div class="articles_content">
          <!-- Manual Scanner -->
          <div class="field">
            <label for="manualQr">Código Etiqueta Simple</label>
            <input id="manualCode" type="text" pInputText placeholder="Escanea el Código QR" [(ngModel)]="manualQrCode"
              (input)="onManualInputChange()" />
          </div>
          <!-- Lista de artículos escaneados -->
          <div class="field">
            <ng-container *ngTemplateOutlet="tablaTemplate"></ng-container>
          </div>
          <!-- Botones de acción -->
          <div class="field">
            <p-button label="Siguiente" icon="pi pi-fast-forward" (click)="onRelease()"
              [disabled]="!scannedItems.length"></p-button>
          </div>
        </div>
        }

        <!-- Release Details-->
        @if (release) {
        <div>
          @if (getReleaseType === 'PERMANENTE') {
          <div class="card">
            @for (msg of messages; track msg) {
            <p-message [severity]="msg.severity" [text]="msg.detail" [closable]="false" />
            }
          </div>
          }
          <form [formGroup]="releaseForm">
            <div class="field">
              <label for="releaseType" class="block mb-2">Tipo de Salida</label>
              <p-select formControlName="releaseType" [options]="releaseTypeOptions" placeholder="Selecciona tipo"
                class="w-full"></p-select>
            </div>
            @if (showTemporalField) {
            <div class="field">
              <label for="groupName" class="block mb-2">Nombre del Grupo <span class="req">*</span></label>
              <input type="text" id="nombreGrupo" pInputText formControlName="groupName" class="w-full" />
            </div>
            }
            <div class="field">
              <label for="exitDate" class="block mb-2">Fecha y Hora de Salida</label>
              <p-datepicker id="fechaSalida" formControlName="exitDate" [showTime]="true" hourFormat="12"
                dateFormat="dd/mm/yy" [showIcon]="true" [touchUI]="true" [readonlyInput]="true"
                class="w-full"></p-datepicker>
            </div>
            @if (!showTemporalField) {
            <div class="field">
              <label for="note" class="block mb-2">Nota <span class="req">*</span></label>
              <textarea id="note" pInputTextarea formControlName="note" rows="3" class="w-full"></textarea>
            </div>
            }
            <!-- Botones -->
            <div class="p-col-12 flex justify-content-between gap-3 mt-4">
              <p-button label="Atrás" icon="pi pi-arrow-left" severity="secondary" class="w-full"
                (click)="onReleaseBack()"></p-button>
              <p-button label="Confirmar" icon="pi pi-check" severity="danger" class="w-full"
                (click)="onReleaseConfirm()" [disabled]="releaseForm.invalid"></p-button>
            </div>
          </form>
        </div>
        }

      </div>
    </p-fluid>
  </p-panel>
</div>

<ng-template #tablaTemplate>
  @if (scannedItems.length) {
  <p-table [value]="scannedItems" styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped">
    <ng-template pTemplate="caption">
      <div class="flex align-items-center justify-content-between text-xs text-color-secondary">
        En total hay {{ scannedItems ? scannedItems.length : 0 }} QR
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th>QR</th>
        <th>Descripción</th>
        <th>#</th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item let-i="rowIndex" let-editing="editing">
      <tr>
        <td>{{ item.code }}</td>
        <td>{{ item.description }}</td>
        <td>{{ item.quantity }}</td>
        <td>
          <p-button icon="pi pi-trash" severity="danger" [outlined]="true" (click)="removeItem(i)"></p-button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="summary">
      <div class="flex align-items-center justify-content-between text-xs text-color-secondary">
        En total hay {{ scannedItems ? scannedItems.length : 0 }} QR
      </div>
    </ng-template>
  </p-table>
  }
</ng-template>

<!-- Dialog to release items -->
<p-dialog header="Salida de Artículos" [(visible)]="deactivationDialogVisible" [modal]="true"
  [style]="{ width: 'clamp(300px, 90vw, 420px)' }">
  <ng-template pTemplate="content">
    <div class="field">
      @if (selectedItem) {
      <div class="p-3 surface-100 border-round">
        <div class="mb-2"><strong>Código:</strong> {{ selectedItem.code }}</div>
        <div class="mb-2"><strong>Descripción:</strong> {{ selectedItem.description }}</div>
        <div class="mb-2"><strong>Cantidad Actual:</strong> {{ selectedItem.quantity }}</div>
      </div>
      }
    </div>
    <div class="field">
      <label for="quantity">Cantidad para Salida</label>
      <p-inputNumber id="quantity" [(ngModel)]="deactivationQuantity" (ngModelChange)="validateQuantity()"
        [showButtons]="true" [min]="1" [max]="selectedItem?.quantity" class="w-full" />
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <p-divider></p-divider>
    <p-button label="Cancelar" severity="secondary" (click)="deactivationDialogVisible = false"></p-button>
    <p-button label="Confirmar" severity="warn" (click)="confirmDeactivation()"></p-button>
  </ng-template>
</p-dialog>

<p-confirmDialog></p-confirmDialog>